import { useCallback } from 'react';
import { UI_CONSTANTS } from '../utils';

interface UseSelectKeyboardProps {
  isOpen: boolean;
  searchable: boolean;
  onToggle: () => void;
  onClose: () => void;
}

/**
 * Hook for handling keyboard interactions in the select component
 */
export const useSelectKeyboard = ({
  isOpen,
  searchable,
  onToggle,
  onClose,
}: UseSelectKeyboardProps) => {
  const handleKeyDown = useCallback((event: React.KeyboardEvent) => {
    const { key } = event;

    switch (key) {
      case UI_CONSTANTS.KEYS.ESCAPE:
        if (isOpen) {
          event.preventDefault();
          onClose();
        }
        break;

      case UI_CONSTANTS.KEYS.ENTER:
      case UI_CONSTANTS.KEYS.SPACE:
        if (!searchable) {
          event.preventDefault();
          onToggle();
        }
        break;

      case UI_CONSTANTS.KEYS.ARROW_DOWN:
      case UI_CONSTANTS.KEYS.ARROW_UP:
        event.preventDefault();
        if (!isOpen) {
          onToggle();
        }
        // TODO: Add arrow key navigation through options
        break;

      default:
        break;
    }
  }, [isOpen, searchable, onToggle, onClose]);

  return { handleKeyDown };
};
